module.exports = __webpack_public_path__ + "static/img/login_logo@3x.ac36e5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_logo@3x.png
// module id = Ajbh
// module chunks = 1